import Vue from 'vue';

require('./bootstrap');
require('./main');
import './helpers/string.helpers';
import './plugins/index';

import swalMessages from "./mixins/swal-messages";

const mixins = [ swalMessages ];
mixins.forEach(mixin => Vue.mixin(mixin));

window.Vue = require('vue');
Vue.config.productionTip = false;

const files = require.context('./', true, /\.vue$/i)
files.keys().map(key => Vue.component(key.split('/').pop().split('.')[0], files(key).default))

/**
 * Next, we will create a fresh Vue application instance and attach it to
 * the page. Then, you may begin adding components to this application
 * or customize the JavaScript scaffolding to fit your unique needs.
 */

const app = new Vue({
    el: '#app',
});
